import {
  ApiClient,
  AuthService,
  EVENT_PLATFORMS,
  EVENTS_ORG,
  LoginMethods,
} from "@pw-tech/web-sdk";

AuthService.getInstance({
  organizationId: process.env.REACT_APP_PUBLIC_ORGANIZATION_ID || "",
  apiBaseUrl: process.env.REACT_APP_API_END_POINT || "",
  loginMethods: [LoginMethods.OTP, LoginMethods.PASSWORD],
  localStorageFallback: true,
  clientId: "system-admin",
  clientSecret: "KjPXuAVfC5xbmgreETNMaL7z",
  contextIdentifier: "TOKEN_CONTEXT",
  loginPageUrl: "/",
  debugMode: true,
  eventConfig: {
    organizationName: EVENTS_ORG.PHYSICS_WALLAH,
    eventPlatforms: [EVENT_PLATFORMS.GA, EVENT_PLATFORMS.MOENGAGE],
    eventsDebugMode: true,
  },
});

type paramType = string | null;

const joinHost = async (params: null | {}, headers = {}) => {
  return await ApiClient.get("/host-join", {
    headers: { ...headers },
    params: { ...params },
  });
};

const joinStudent = async (params: null | {}, authToken: paramType) => {
  return await ApiClient.get("/student-join", {
    headers: { Authorization: `Bearer ${authToken}` },
    params: { ...params },
  });
};

const publicStudent = async (params: null | {}, authToken: paramType) => {
  return await ApiClient.get("/public-join", {
    headers: { Authorization: `Bearer ${authToken}` },
    params: { ...params },
  });
};

export const zoomServices = {
  joinStudent,
  publicStudent,
  joinHost,
};
